export const pokedexGen5 = {
  "pokedex495": "Serpifeu",
  "pokedex496": "Efoserp",
  "pokedex497": "Serpiroyal",
  "pokedex498": "Floink",
  "pokedex499": "Ferkokel",
  "pokedex500": "Flambirex",
  "pokedex501": "Ottaro",
  "pokedex502": "Zwottronin",
  "pokedex503": "Admurai",
  "pokedex504": "Nagelotz",
  "pokedex505": "Kukmarda",
  "pokedex506": "Yorkleff",
  "pokedex507": "Terribark",
  "pokedex508": "Bissbark",
  "pokedex509": "Felilou",
  "pokedex510": "Kleoparda",
  "pokedex511": "Vegimak",
  "pokedex512": "Vegichita",
  "pokedex513": "Grillmak",
  "pokedex514": "Grillchita",
  "pokedex515": "Sodamak",
  "pokedex516": "Sodachita",
  "pokedex517": "Somniam",
  "pokedex518": "Somnivora",
  "pokedex519": "Dusselgurr",
  "pokedex520": "Navitaub",
  "pokedex521": "Fasasnob",
  "pokedex522": "Elezeba",
  "pokedex523": "Zebritz",
  "pokedex524": "Kiesling",
  "pokedex525": "Sedimantur",
  "pokedex526": "Brockoloss",
  "pokedex527": "Fleknoil",
  "pokedex528": "Fletiamo",
  "pokedex529": "Rotomurf",
  "pokedex530": "Stalobor",
  "pokedex531": "Ohrdoch",
  "pokedex532": "Praktibalk",
  "pokedex533": "Strepoli",
  "pokedex534": "Meistagrif",
  "pokedex535": "Schallquap",
  "pokedex536": "Mebrana",
  "pokedex537": "Branawarz",
  "pokedex538": "Jiutesto",
  "pokedex539": "Karadonis",
  "pokedex540": "Strawickl",
  "pokedex541": "Folikon",
  "pokedex542": "Matrifol",
  "pokedex543": "Toxiped",
  "pokedex544": "Rollum",
  "pokedex545": "Cerapendra",
  "pokedex546": "Waumboll",
  "pokedex547": "Elfun",
  "pokedex548": "Lilminip",
  "pokedex549": "Dressella",
  "pokedex550": "Barschuft",
  "pokedex551": "Ganovil",
  "pokedex552": "Rokkaiman",
  "pokedex553": "Rabigator",
  "pokedex554": "Flampion",
  "pokedex555": "Flampivian",
  "pokedex556": "Maracamba",
  "pokedex557": "Lithomith",
  "pokedex558": "Castellith",
  "pokedex559": "Zurrokex",
  "pokedex560": "Irokex",
  "pokedex561": "Symvolara",
  "pokedex562": "Makabaja",
  "pokedex563": "Echnatoll",
  "pokedex564": "Galapaflos",
  "pokedex565": "Karippas",
  "pokedex566": "Flapteryx",
  "pokedex567": "Aeropteryx",
  "pokedex568": "Unratütox",
  "pokedex569": "Deponitox",
  "pokedex570": "Zorua",
  "pokedex571": "Zoroark",
  "pokedex572": "Picochilla",
  "pokedex573": "Chillabell",
  "pokedex574": "Mollimorba",
  "pokedex575": "Hypnomorba",
  "pokedex576": "Morbitesse",
  "pokedex577": "Monozyto",
  "pokedex578": "Mitodos",
  "pokedex579": "Zytomega",
  "pokedex580": "Piccolente",
  "pokedex581": "Swaroness",
  "pokedex582": "Gelatini",
  "pokedex583": "Gelatroppo",
  "pokedex584": "Gelatwino",
  "pokedex585": "Sesokitz",
  "pokedex586": "Kronjuwild",
  "pokedex587": "Emolga",
  "pokedex588": "Laukaps",
  "pokedex589": "Cavalanzas",
  "pokedex590": "Tarnpignon",
  "pokedex591": "Hutsassa",
  "pokedex592": "Quabbel",
  "pokedex593": "Apoquallyp",
  "pokedex594": "Mamolida",
  "pokedex595": "Wattzapf",
  "pokedex596": "Voltula",
  "pokedex597": "Kastadur",
  "pokedex598": "Tentantel",
  "pokedex599": "Klikk",
  "pokedex600": "Kliklak",
  "pokedex601": "Klikdiklak",
  "pokedex602": "Zapplardin",
  "pokedex603": "Zapplalek",
  "pokedex604": "Zapplarang",
  "pokedex605": "Pygraulon",
  "pokedex606": "Megalon",
  "pokedex607": "Lichtel",
  "pokedex608": "Laternecto",
  "pokedex609": "Skelabra",
  "pokedex610": "Milza",
  "pokedex611": "Sharfax",
  "pokedex612": "Maxax",
  "pokedex613": "Petznief",
  "pokedex614": "Siberio",
  "pokedex615": "Frigometri",
  "pokedex616": "Schnuthelm",
  "pokedex617": "Hydragil",
  "pokedex618": "Flunschlik",
  "pokedex619": "Lin‑Fu",
  "pokedex620": "Wie‑Shu",
  "pokedex621": "Shardrago",
  "pokedex622": "Golbit",
  "pokedex623": "Golgantes",
  "pokedex624": "Gladiantri",
  "pokedex625": "Caesurio",
  "pokedex626": "Bisofank",
  "pokedex627": "Geronimatz",
  "pokedex628": "Washakwil",
  "pokedex629": "Skallyk",
  "pokedex630": "Grypheldis",
  "pokedex631": "Furnifraß",
  "pokedex632": "Fermicula",
  "pokedex633": "Kapuno",
  "pokedex634": "Duodino",
  "pokedex635": "Trikephalo",
  "pokedex636": "Ignivor",
  "pokedex637": "Ramoth",
  "pokedex638": "Kobalium",
  "pokedex639": "Terrakium",
  "pokedex640": "Viridium",
  "pokedex641": "Boreos",
  "pokedex642": "Voltolos",
  "pokedex643": "Reshiram",
  "pokedex644": "Zekrom",
  "pokedex645": "Demeteros",
  "pokedex646": "Kyurem",
  "pokedex647": "Keldeo",
  "pokedex648": "Meloetta",
  "pokedex649": "Genesect"
};